// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { DBConstraint } from './DBConstraint';
import { DBTable } from './DBTable';
import { DBColumn } from './DBColumn';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 外键约束 实体类
 * 外键约束
 */
export class ForeignKey extends DBConstraint {
  /** 是否级联更新 : 是否级联更新 */
  private _isCascadeUpdate: boolean;

  /** 设置：是否级联更新 */
  public get isCascadeUpdate() {
    return this._isCascadeUpdate;
  }

  /** 获取：是否级联更新 */
  public set isCascadeUpdate(value: boolean) {
    this._isCascadeUpdate = value;
  }

  /** 是否级联删除 : 是否级联删除 */
  private _isCascadeDelete: boolean;

  /** 设置：是否级联删除 */
  public get isCascadeDelete() {
    return this._isCascadeDelete;
  }

  /** 获取：是否级联删除 */
  public set isCascadeDelete(value: boolean) {
    this._isCascadeDelete = value;
  }

  /** 级联更新设置为null : 级联更新设置为null */
  private _isCascadeUpdateNull: boolean;

  /** 设置：级联更新设置为null */
  public get isCascadeUpdateNull() {
    return this._isCascadeUpdateNull;
  }

  /** 获取：级联更新设置为null */
  public set isCascadeUpdateNull(value: boolean) {
    this._isCascadeUpdateNull = value;
  }

  /** 级联删除设置为null : 级联删除设置为null */
  private _isCascadeDeleteNull: boolean;

  /** 设置：级联删除设置为null */
  public get isCascadeDeleteNull() {
    return this._isCascadeDeleteNull;
  }

  /** 获取：级联删除设置为null */
  public set isCascadeDeleteNull(value: boolean) {
    this._isCascadeDeleteNull = value;
  }

  /** 数据库表 的ID */
  private _table_ID: string;

  /** 获取：数据库表 的ID */
  public get table_ID() {
    return this._table_ID;
  }

  /** 设置：数据库表 的ID */
  public set table_ID(value: string) {
    this._table_ID = value;
  }

  /** 数据库表  */
  private _table: DBTable;

  /** 获取：数据库表  */
  public get table() {
    return this._table;
  }

  /** 设置：数据库表  */
  public set table(value: DBTable) {
    this._table = value;
    if (value !== null) {
      this.table_ID = value.id;
    } else {
      this.table_ID = '';
    }
  }

  /** 列 的ID */
  private _column_ID: string;

  /** 获取：列 的ID */
  public get column_ID() {
    return this._column_ID;
  }

  /** 设置：列 的ID */
  public set column_ID(value: string) {
    this._column_ID = value;
  }

  /** 列  */
  private _column: DBColumn;

  /** 获取：列  */
  public get column() {
    return this._column;
  }

  /** 设置：列  */
  public set column(value: DBColumn) {
    this._column = value;
    if (value !== null) {
      this.column_ID = value.id;
    } else {
      this.column_ID = '';
    }
  }

  /** 引用列 的ID */
  private _referenceColumn_ID: string;

  /** 获取：引用列 的ID */
  public get referenceColumn_ID() {
    return this._referenceColumn_ID;
  }

  /** 设置：引用列 的ID */
  public set referenceColumn_ID(value: string) {
    this._referenceColumn_ID = value;
  }

  /** 引用列  */
  private _referenceColumn: DBColumn;

  /** 获取：引用列  */
  public get referenceColumn() {
    return this._referenceColumn;
  }

  /** 设置：引用列  */
  public set referenceColumn(value: DBColumn) {
    this._referenceColumn = value;
    if (value !== null) {
      this.referenceColumn_ID = value.id;
    } else {
      this.referenceColumn_ID = '';
    }
  }

  constructor() {
    super();
    this._isCascadeUpdate = false;
    this._isCascadeDelete = false;
    this._isCascadeUpdateNull = false;
    this._isCascadeDeleteNull = false;
    this._table_ID = '';
    this._table = null;
    this._column_ID = '';
    this._column = null;
    this._referenceColumn_ID = '';
    this._referenceColumn = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ForeignKey, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isCascadeUpdate = element.isCascadeUpdate;
      this.isCascadeDelete = element.isCascadeDelete;
      this.isCascadeUpdateNull = element.isCascadeUpdateNull;
      this.isCascadeDeleteNull = element.isCascadeDeleteNull;
      this.table_ID = element.table_ID;
      if (hasReference && element.table !== null) {
        this.table = element.table;
      }
      this.column_ID = element.column_ID;
      if (hasReference && element.column !== null) {
        this.column = element.column;
      }
      this.referenceColumn_ID = element.referenceColumn_ID;
      if (hasReference && element.referenceColumn !== null) {
        this.referenceColumn = element.referenceColumn;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isCascadeUpdate = json.IsCascadeUpdate;
    this.isCascadeDelete = json.IsCascadeDelete;
    this.isCascadeUpdateNull = json.IsCascadeUpdateNull;
    this.isCascadeDeleteNull = json.IsCascadeDeleteNull;
    this.table_ID = json.Table_ID;
    // if (json.Table !== null) {
    //   this.table = DBTable.Create(json.Table);
    // }
    this.column_ID = json.Column_ID;
    // if (json.Column !== null) {
    //   this.column = DBColumn.Create(json.Column);
    // }
    this.referenceColumn_ID = json.ReferenceColumn_ID;
    // if (json.ReferenceColumn !== null) {
    //   this.referenceColumn = DBColumn.Create(json.ReferenceColumn);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsCascadeUpdate = this.isCascadeUpdate;
    json.IsCascadeDelete = this.isCascadeDelete;
    json.IsCascadeUpdateNull = this.isCascadeUpdateNull;
    json.IsCascadeDeleteNull = this.isCascadeDeleteNull;
    json.Table_ID = this.table_ID;
    json.Column_ID = this.column_ID;
    json.ReferenceColumn_ID = this.referenceColumn_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'isCascadeUpdate', '是否级联更新', EnumDataType.Bool, this.isCascadeUpdate, true, '是否级联更新', '', '');
    context.addRow('基本属性', 'isCascadeDelete', '是否级联删除', EnumDataType.Bool, this.isCascadeDelete, true, '是否级联删除', '', '');
    context.addRow('基本属性', 'isCascadeUpdateNull', '级联更新设置为null', EnumDataType.Bool, this.isCascadeUpdateNull, true, '级联更新设置为null', '', '');
    context.addRow('基本属性', 'isCascadeDeleteNull', '级联删除设置为null', EnumDataType.Bool, this.isCascadeDeleteNull, true, '级联删除设置为null', '', '');
    return context;
  }

  static Create(json: any): ForeignKey {
    const foreignKey = new ForeignKey();
    foreignKey.Deserialize(json);
    foreignKey.json = json;
    return foreignKey;
  }
}
